import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import type { ShoppingWizardData } from './interfaces.js';

export const resultsSection = (
  shoppingWizardData: ShoppingWizardData | undefined,
  planType: 'MAPD' | 'Supp' | 'PDP',
) => {
  if (shoppingWizardData) {
    const resultsData = shoppingWizardData['results'];
    const planData = shoppingWizardData['planTool'];

    const renderPlanFinder = () => {
      return html`
        <chcapp-medicare-plan-finder variant="wizard" plantype="${planType}" hidden></chcapp-medicare-plan-finder>
      `;
    };

    return html`
      ${resultsData.map(
        (result) => html`
          <div class="results" data-result="${result.result}" hidden>
            <div>${unsafeHTML(result.paragraph)}</div>
            <ul>
              ${result.listContents.map((listItem) => html`<li>${unsafeHTML(listItem.content)}</li>`)}
            </ul>
            <h3>${planData.header}</h3>
            ${unsafeHTML(planData.leadin)}
          </div>
        `,
      )}
      ${renderPlanFinder()}
      ${resultsData.map(
        (result) => html`
          <div class="results" data-result="${result.result}" hidden>
            ${unsafeHTML(result.phoneLead)}
            <leaf-list>
              <h4 class="leaf-u-color-content-brand-strong" slot="heading">${result.header}</h4>
              ${result.links.map((linkItem) => html`<li>${unsafeHTML(linkItem.link)}</li>`)}
            </leaf-list>
          </div>
        `,
      )}
    `;
  } else {
    return;
  }
};
